import 'font-awesome/css/font-awesome.css';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import './components/Common/ToolBarSearch.scss';
import React from 'react';
import * as msal from '@azure/msal-browser';
import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { ReduxRouter } from '@lagunovsky/redux-react-router';
import { AppInsightsErrorBoundary } from "@microsoft/applicationinsights-react-js";
import { registerLicense } from '@syncfusion/ej2-base';
import { createBrowserHistory } from 'history';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ajax } from 'rxjs/ajax';
import { map } from 'rxjs/operators';
import App from 'App';
import { getAppInsights, initAppInsights, reactPlugin } from './ApplicationInsights';
import { unregister } from './registerServiceWorker';
import configureStore from './store/configureStore';
import { configurationService } from './subjects/crossModules/ConfigurationService';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

const rootElement = document.getElementById('root');

const getUrlVars = () => {
    var vars = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
        vars[key] = value;
    });
    return vars;
};
const urlAccessToken = getUrlVars()['cc_access_token'];

const renderRoot = () => {
    ReactDOM.render(
        <Provider store={store}>
            <ReduxRouter history={history} store={store}>
                <AppInsightsErrorBoundary onError={() => <h1>something went wrong</h1>} appInsights={reactPlugin}>
                    <App history={history} />
                </AppInsightsErrorBoundary>
            </ReduxRouter>
        </Provider>,
        rootElement
    );

    unregister();
};

if (urlAccessToken) {
    const appInsights = getAppInsights();
    appInsights.trackEvent({ name: 'AVA-Member-UI-Login-UrlAccessToken' });
    sessionStorage.setItem('cc_access_token', urlAccessToken);
    renderRoot();
} else {
    ajax('api/Config/B2C')
        .pipe(map((response) => response.response))
        .subscribe((config) => {
            const appInsights = getAppInsights();
            configurationService.set(config);

            // Registering Syncfusion license key
            registerLicense(config.syncfusionLicenseKey);

            const { cacheLocation, scopes, clientId, tenantName, authority } = config;
            const azureAdB2CHostname = `${tenantName}.b2clogin.com`;

            const msalConfig = {
                auth: {
                    clientId: clientId,
                    knownAuthorities: [azureAdB2CHostname], // You must identify your tenant's domain as a known authority.
                    redirectUri: window.location.origin,
                    authority, // Choose sign-up/sign-in user-flow as your default.
                    postLogoutRedirectUri: window.location.origin,
                },
                cache: {
                    cacheLocation, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
                    storeAuthStateInCookie: false, // If you wish to store cache items in cookies as well as browser cache, set this to "true".
                },
            };
            const msalInstance = new msal.PublicClientApplication(msalConfig);
            const loginRequest = { scopes };

            initAppInsights(config.instrumentationKey, history);
            getAppInsights();
            ReactDOM.render(
                <MsalProvider instance={msalInstance}>
                    <MsalAuthenticationTemplate
                        interactionType={InteractionType.Redirect}
                        authenticationRequest={loginRequest}
                    >
                        <Provider store={store}>
                            <ReduxRouter history={history} store={store}>
                                <AppInsightsErrorBoundary onError={() => <h1>something went wrong</h1>} appInsights={reactPlugin}>
                                    <App history={history} />
                                </AppInsightsErrorBoundary>
                            </ReduxRouter>
                        </Provider>
                    </MsalAuthenticationTemplate>
                </MsalProvider>,
                rootElement
            );

            unregister();
        });
}
